import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  model,
  signal,
} from '@angular/core';
import { User } from '@core/interfaces/user.interface';
import { NgpRadioGroup, NgpRadioItem } from 'ng-primitives/radio';
import { CheckboxComponent } from '../../../core/components/checkbox/checkbox.component';
import { SocketService } from '@core/services/socket.service';
import { ToastrService } from 'ngx-toastr';

type BanDurationKeys = '1' | '8' | '12' | '24' | '48' | '72';

@Component({
  selector: 'app-user-self-exclusion',
  imports: [NgpRadioGroup, NgpRadioItem, CheckboxComponent],
  templateUrl: './user-self-exclusion.component.html',
  styleUrl: './user-self-exclusion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UserSelfExclusionComponent {
  private readonly socketService = inject(SocketService);
  private readonly toastrService = inject(ToastrService);

  user = input.required<User>();

  readonly banDurationOptions = [
    { key: 1, value: '1 hour' },
    { key: 8, value: '8 hour' },
    { key: 12, value: '12 hour' },
    { key: 24, value: '24 hour' },
    { key: 48, value: '2 days' },
    { key: 72, value: '3 days' },
  ];
  readonly banDuration = signal<BanDurationKeys>('1');
  readonly currentOption = computed(() => {
    return this.banDurationOptions.find(
      (option) => String(option.key) === this.banDuration()
    );
  });
  readonly isUnderstandSelfExclusion = model<boolean>(false);

  public async handleSelfExclusion() {
    const option = this.currentOption();
    if (!this.isUnderstandSelfExclusion()) {
      this.toastrService.error(
        'You must understand the consequences of self-exclusion before proceeding.',
        'Error'
      );
      return;
    }
    if (!option) {
      this.toastrService.error('Please select a valid ban duration.', 'Error');
      return;
    }
    const results = await this.socketService.emit('self_ban', {
      time: option.key,
    });

    this.toastrService.success(results);
  }
}
